import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  setBracketAttachmentLoadF,
  setBracketAttachmentLoadL,
  setBracketAttachmentLoadLg,
  setBracketAttachmentLoadNr,
  setBracketAttachmentWeightP
} from '@reducers/selectors/loads/actions';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

import Input from '@components/Input';

import './styles.scss';
import { APP_TYPES } from '@config';
import { APP_TEXTS } from '../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../src/texts/tooltips';

// eslint-disable-next-line react/prefer-stateless-function
class DesignLoading extends Component {

  render() {
    return (
      <div className="calculation design-loading">
        <section className="list-type">
          <h4>{APP_TEXTS.LOAD_APPLICATION_POINT.Content}</h4>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_DISTANCE_L_FROM_F.Content}>
          <Input
            id="l"
            prefix="L"
            postfix={unitLabel(this.props.distanceUnit)}
            type="number"
            onUpdate={value => {
              this.props.setL(
                unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
              );
            }}
            value={unitTransform(this.props.loads.l).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
          />
          </Tooltip>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_DISTANCE_LG_FROM_DEAD_WEIGHT.Content}>
          <Input
            id="lg"
            prefix="Lg"
            postfix={unitLabel(this.props.distanceUnit)}
            type="number"
            onUpdate={value => {
              this.props.setLg(
                unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
              );
            }}
            value={unitTransform(this.props.loads.lg).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
            maxValue={unitTransform(this.props.loads.l).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
          />
          </Tooltip>
        </section>

        <section className="list-type">
          <h4>{APP_TEXTS.LOADS_ON_BRACKET.Content}</h4>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_F_APPLIED_AT_DISTANCE_L.Content}>
          <Input
            id="load-f"
            prefix={APP_TEXTS.BRACKET_DESIGN_LOAD_F.Content}//"Load F"
            postfix={unitLabel(this.props.loadUnit)}
            type="number"
            onUpdate={value => {
              this.props.setF(
                unitTransform(+value, false).from(this.props.loadUnit).to(defaultUnits.LOAD)
              );
            }}
            value={unitTransform(this.props.loads.loadF).from(defaultUnits.LOAD).to(this.props.loadUnit)}
          />
          </Tooltip>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_TENSILE_LOAD_APPLIED_IN_PROFILE_AXIS.Content}>
          <Input
            id="load-nr"
            prefix={APP_TEXTS.BRACKET_DESIGN_LOAD_NR.Content} //"Load NR"
            postfix={unitLabel(this.props.loadUnit)}
            type="number"
            onUpdate={value => {
              this.props.setNr(
                unitTransform(+value, false).from(this.props.loadUnit).to(defaultUnits.LOAD)
              );
            }}
            value={unitTransform(this.props.loads.loadNr).from(defaultUnits.LOAD).to(this.props.loadUnit)}
          />
          </Tooltip>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_WEIGHT_APPLIED_AT_DISTANCE_LG.Content}>
          <Input
            id="weight-p"
            prefix={APP_TEXTS.BRACKET_DESIGN_WEIGHT_P.Content} //"Weight P"
            postfix={unitLabel(this.props.weightUnit)}
            type="number"
            onUpdate={value => {
              this.props.setWeightP(
                unitTransform(+value, false).from(this.props.weightUnit).to(defaultUnits.WEIGHT)
              );
            }}
            value={unitTransform(this.props.loads.weightP).from(defaultUnits.WEIGHT).to(this.props.weightUnit)}
          />
          </Tooltip>
        </section>
      </div>
    );
  }

}

const mapState = state => {
  return {
    loads: state.selectors.loads[APP_TYPES.BRACKET_ATTACHMENT],

    distanceUnit: state.main.units.distance,
    loadUnit: state.main.units.load,
    weightUnit: state.main.units.weight
  };
};

const mapDispatch = dispatch => ({
  setL: value => dispatch(setBracketAttachmentLoadL(value)),
  setLg: value => dispatch(setBracketAttachmentLoadLg(value)),
  setF: value => dispatch(setBracketAttachmentLoadF(value)),
  setNr: value => dispatch(setBracketAttachmentLoadNr(value)),
  setWeightP: value => dispatch(setBracketAttachmentWeightP(value))
});

export default connect(mapState, mapDispatch)(DesignLoading);



// WEBPACK FOOTER //
// ./src/views/Loads/BracketDesignLoading/index.js